import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import epsClient from 'enrollment-platform/api/eps.client'
import {
  TEMPLATE_TYPE_LABELS,
  TemplateType,
} from '../../../models/templateType'

/** Row from GET /api/v1/hris-mapping-templates/active (non-empty rules only) */
export interface ActiveHrisMappingTemplate {
  id: string
  type: TemplateType
  companyName: string
  clientPublicKey: string
  name: string
  mappingRules: {
    schema_version: string
    computed_fields?: unknown[]
    mapping_rules: unknown[]
  }
}

async function fetchActiveTemplatesWithRules(): Promise<
  ActiveHrisMappingTemplate[]
> {
  const { data } = await epsClient.get<ActiveHrisMappingTemplate[]>(
    '/api/v1/hris-mapping-templates/active'
  )
  return data.filter((t) => (t.mappingRules?.mapping_rules?.length ?? 0) > 0)
}

export default function useActiveHrisTemplatesForImport(enabled: boolean) {
  const { data: activeImportTemplates = [], isPending: isLoading } = useQuery({
    queryKey: ['hris-mapping-templates-active-with-rules'],
    queryFn: fetchActiveTemplatesWithRules,
    enabled,
  })

  const importSelectOptions = useMemo(
    () =>
      activeImportTemplates.map((t) => ({
        value: t.id,
        label: `${t.companyName} — ${TEMPLATE_TYPE_LABELS[t.type] ?? t.type}`,
      })),
    [activeImportTemplates]
  )

  return {
    activeImportTemplates,
    importSelectOptions,
    isLoading,
  }
}
